import React from "react";

const SearchFilter = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  genderFilter,
  setGenderFilter,
  voucherGenerationStartDate,
  setVoucherGenerationStartDate,
  voucherGenerationEndDate,
  setVoucherGenerationEndDate,
  patientStartDate,
  setPatientStartDate,
  patientEndDate,
  setPatientEndDate,
  categoryFilter,
  setCategoryFilter,
  categoryOptions = [],
  statusOptions = ["Assigned", "Redeemed", "Expired"],
  genderOptions = ["Male", "Female"],
}) => {
  return (
    <div className="date-filters">
      {setSearchTerm && (
        <div className="date-filter-group-search">
          <h4>Search</h4>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      )}

      {setStatusFilter && (
        <div className="date-filter-group-select">
          <h4>Status</h4>
          <select
            value={statusFilter || ""}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All Status</option>
            {statusOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {setGenderFilter && (
        <div className="date-filter-group-select">
          <h4>Gender</h4>
          <select
            value={genderFilter || ""}
            onChange={(e) => setGenderFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All</option>
            {genderOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {setCategoryFilter && (
        <div className="date-filter-group-select">
          <h4>Category</h4>
          <select
            value={categoryFilter || ""}
            onChange={(e) => setCategoryFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All Categories</option>
            {categoryOptions.map((option) => (
              <option key={option.tid} value={option.tid}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {(setVoucherGenerationStartDate || setVoucherGenerationEndDate) && (
        <div className="date-filter-group">
          <h4>Generated date</h4>
          {setVoucherGenerationStartDate && (
            <label>
              Start :
              <input
                className="styled-date"
                type="date"
                value={voucherGenerationStartDate || ""}
                onChange={(e) => setVoucherGenerationStartDate(e.target.value)}
              />
            </label>
          )}
          {setVoucherGenerationEndDate && (
            <label>
              End :
              <input
                className="styled-date"
                type="date"
                value={voucherGenerationEndDate || ""}
                onChange={(e) => setVoucherGenerationEndDate(e.target.value)}
              />
            </label>
          )}
        </div>
      )}

      {(setPatientStartDate || setPatientEndDate) && (
        <div className="date-filter-group">
          <h4>Registered date</h4>
          {setPatientStartDate && (
            <label>
              Start :
              <input
                className="styled-date"
                type="date"
                value={patientStartDate || ""}
                onChange={(e) => setPatientStartDate(e.target.value)}
              />
            </label>
          )}
          {setPatientEndDate && (
            <label>
              End :
              <input
                className="styled-date"
                type="date"
                value={patientEndDate || ""}
                onChange={(e) => setPatientEndDate(e.target.value)}
              />
            </label>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchFilter;
